import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  inset: 0;
  z-index: 9999;

  background-color: rgb(211 228 255 /70%);
  backdrop-filter: blur(4px);

  animation: entering 0.5s forwards;

  &.modal-agenda-details--hide{
    animation: exiting 0.5s forwards;
  }
`

export const ModalContainer = styled.article`
  max-height: 99vh;
  max-width: 98vw;
  padding: 42.2px;

  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-radius: 32px;
  background: white;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16)
`

export const ModalCloseButton = styled.button`
  width: fit-content;
  height: fit-content;

  position: absolute;
  top: 42.2px;
  right: 29.9px;

  border: 0;
  font-size: 22px;
  font-weight: bold;
  color: var(--blue02);
  background-color: transparent;
  cursor: pointer;

  transition: filter 0.3s;

  &:hover {
    filter: brightness(1.1);
  }
`

export const ProductPhoto = styled.img`
  object-fit: cover;
  max-height: 50vh;
`
